import type { ICellValue, ICheckboxFieldProperty } from '../types'

import z from 'zod'

import { getFieldDefaultProperty } from '../constants'
import { BasicValueType, FieldType, FOperator } from '../types'
import { Field } from './field'

const trueText = ['1', 'true', 'checked']
const falseText = ['0', 'false', 'unchecked']
export class CheckboxField extends Field {
	static readonly propertySchema = z.null()
	static readonly cellValueSchema = z.boolean().nullable()

	static readonly openWriteValueValueSchema = z.boolean().nullable()

	static readonly _acceptFilterOperators = [FOperator.Is]

	get openValueSchema() {
		return z.boolean().nullable()
	}

	get basicValueType(): BasicValueType {
		return BasicValueType.Boolean
	}

	get acceptFilterOperators(): FOperator[] {
		return CheckboxField._acceptFilterOperators
	}

	static defaultProperty(): ICheckboxFieldProperty {
		return getFieldDefaultProperty(FieldType.Flag) as ICheckboxFieldProperty
	}

	validateProperty() {
		return CheckboxField.propertySchema.safeParse(this.field.property)
	}

	validateCellValue(cv: ICellValue) {
		return CheckboxField.cellValueSchema.safeParse(cv)
	}

	validateOpenWriteValue(owv: boolean | null) {
		return CheckboxField.openWriteValueValueSchema.safeParse(owv)
	}

	cellValueToStdValue(cellValue: boolean): string {
		return cellValue ? '1' : '0'
	}
	coerceValue(value: any): boolean | null {
		if (typeof value === 'boolean') {
			return value
		}
		if (typeof value === 'string') {
			return this.stdValueToCellValue(value)
		}

		return null
	}
	stdValueToCellValue(stdValue: string): boolean | null {
		if (trueText.includes(stdValue)) {
			return true
		}
		if (falseText.includes(stdValue)) {
			return null
		}

		return null
	}

	validate(value: any): boolean {
		return value == null || typeof value === 'boolean'
	}

	cellValueToString(cellValue: ICellValue): string {
		return cellValue ? '1' : '0'
	}

	cellValueToApiStandardValue(cellValue: ICellValue): boolean | null {
		return cellValue === true
	}

	cellValueToApiStringValue(cellValue: ICellValue): string | null {
		return this.cellValueToString(cellValue)
	}

	cellValueToOpenValue(cellValue: ICellValue): boolean | null {
		return cellValue === true
	}

	openWriteValueToCellValue(openWriteValue: boolean | null) {
		return openWriteValue
	}
}
